import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactElement } from 'react';

import { CardSlider, CardSliderProps } from '../card-slider';
import { SupplierCardProps, SupplierOfferCard } from './supplier-card/supplier-offer-card';
import { SupplierSpecialOffer } from '../../../models/supplier-special-offer';

export interface SupplierOfferSliderProps
    extends PropsWithChildren,
        Pick<CardSliderProps<SupplierSpecialOffer>, 'showAllUrl' | 'totalItems' | 'onLoadMore'>,
        Pick<SupplierCardProps, 'onClick'> {
    offers: SupplierSpecialOffer[];
}

export const SupplierOfferSlider = (props: SupplierOfferSliderProps): ReactElement | null => {
    return (
        <CardSlider
            items={props.offers}
            renderComponent={item => (
                <SupplierOfferCard
                    key={item.id}
                    specialOffer={item}
                    onClick={props.onClick}
                    sx={{ maxWidth: '287px' }}
                />
            )}
            title={<FormattedMessage id="app.supplierOffer.slider.title" />}
            showAllUrl={props.showAllUrl}
            totalItems={props.totalItems}
            onLoadMore={props.onLoadMore}
        />
    );
};
